import { createSelector } from 'reselect';
import { getInvestmentCalculators } from './index';
import {
	getSelectedGoal,
	getShowLongTermGoalDropField,
	getShowLongTermGoalSplitForm,
} from './investmentCalculator';
import { getAmountOnceOffValue, getLongTermGoalCalculatorForm, getMonthlyAmountValue } from './longTermGoalCalculator';

export const getLongTermGoalFundSplit = createSelector(
	getInvestmentCalculators,
	(investmentCalculators) => investmentCalculators.longTermGoalFundSplit
);

export const getFundSplitForm = createSelector(
	getLongTermGoalFundSplit,
	(longTermGoalFundSplit) => longTermGoalFundSplit.form
);

export const getIsEvenSplit = createSelector(
	getLongTermGoalFundSplit,
	(fundSplit) => fundSplit.isEvenSplit
);

export const getEquityFundValue = createSelector(
	getFundSplitForm,
	(fundSplit) => fundSplit.equityFund
);

export const getBalancedFundValue = createSelector(
	getFundSplitForm,
	(fundSplit) => fundSplit.balancedFund
);

export const getSplitError = createSelector(
	getLongTermGoalFundSplit,
	(fundSplit) => fundSplit.splitError
);

export const getTotalPercentage = createSelector(
	getLongTermGoalFundSplit,
	(fundSplit) => fundSplit.totalPercentage
);

export const getLongTermGoalFundSplitForm = createSelector(
	getLongTermGoalFundSplit,
	(fundSplit) => fundSplit.form
);

export const getEquityFundSplitValue = createSelector(
	[
		getEquityFundValue,
		getLongTermGoalCalculatorForm,
		getShowLongTermGoalSplitForm,
	],
	(equityFund, longTermGoal, showSplitForm) => {
		if (!showSplitForm) {
			return 0;
		}
		const total =
			Number(longTermGoal.amountOnceOff.value || 0) +
			Number(longTermGoal.amountMonthly.value || 0);
		return total * (Number(equityFund.value || 0) / 100);
	}
);

export const getBalancedFundSplitValue = createSelector(
	[
		getBalancedFundValue,
		getLongTermGoalCalculatorForm,
		getShowLongTermGoalSplitForm,
	],
	(balancedFund, longTermGoal, showSplitForm) => {
		if (!showSplitForm) {
			return 0;
		}
		const total =
			Number(longTermGoal.amountOnceOff.value || 0) +
			Number(longTermGoal.amountMonthly.value || 0);
		return total * (Number(balancedFund.value || 0) / 100);
	}
);

export const getLTGDataWithSplit = createSelector(
	[
		getEquityFundValue,
		getBalancedFundValue,
		getShowLongTermGoalDropField,
		getAmountOnceOffValue,
		getMonthlyAmountValue,
		getSelectedGoal,
		getLongTermGoalCalculatorForm,
		getShowLongTermGoalSplitForm
	],
	(
		equityFundValue,
		balancedFundValue,
		sendDrop,
		initialAmount,
		monthlyAmount,
		goal,
		LTGCalculatorForm,
		showSplitForm
	) => {
		const { potentialLossPercentage: {value : drop}, investmentTenure: {value: tenure} } = LTGCalculatorForm;
		if (tenure === '12' && drop === '0') {
			return  {
				initial_amount: initialAmount.value,
				goal,
				monthly_savings: monthlyAmount.value,
				productitems: [{ id: 24 }]
			}; //mmf
		}
		if (sendDrop && drop === '0.05') {
			return  {
				initial_amount: initialAmount.value,
				goal,
				monthly_savings: monthlyAmount.value,
				productitems: [{ id: 21 }]
			}; //balanced
		}
		if(showSplitForm && drop === '0.1'){
			return {
				initial_amount: initialAmount.value,
				goal,
				monthly_savings: monthlyAmount.value,
				productitems: [
					{ id: 20, percent_split: equityFundValue.value }, //equity
					{ id: 21, percent_split: balancedFundValue.value }, //balanced
				],
			};
		}
		if (sendDrop && drop === '>0.1'){
			return {
				initial_amount: initialAmount.value,
				monthly_savings: monthlyAmount.value,
				productitems: [
					{id: 20}
				],
				goal
			}
		}
		else {
			return {
				productitems: [{id: 24}],
				initial_amount: initialAmount.value,
				monthly_savings:  monthlyAmount.value,
				goal,
			}
		}
	})
